import { Text } from '@rtkwlf/c3-core-react';

import styles from './security-focus-timeline-item-empty.module.css';

type SecurityFocusTimelineItemEmptyProps = {
  description: string;
  icon: React.ReactNode;
  title: string;
};

export const SecurityFocusTimelineItemEmpty: React.FunctionComponent<
  SecurityFocusTimelineItemEmptyProps
> = ({ description, icon, title }) => {
  return (
    <div
      className={styles['sft-item-empty']}
      data-testid="security-focus-timeline-item-empty"
    >
      {icon}
      <Text align="center" contrast="medium" weight="bold">
        {title}
      </Text>
      <Text align="center" contrast="medium" size="3">
        {description}
      </Text>
    </div>
  );
};
